import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const DQSummaryTable = ({
  assets = [],
  finalResult = false,
  ruleSuggestionsLoading = false,
  ruleSuggestionsLoadingId = null,
  onFetchRuleSuggestions = () => {},
  onOpenConfig = () => {},
  onViewResult = () => {},
  getDQStatusPill = () => null,
}) => {
  const renderStatusPill = (status) => {
    let background = "#fff3e0";
    let color = "#f57c00";
    if (status === "Completed") {
      background = "#e8f5e8";
      color = "#2e7d32";
    } else if (status === "Failed") {
      background = "#ffeaea";
      color = "#d32f2f";
    }
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: 2,
          py: 0.5,
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 600,
          textTransform: "uppercase",
          backgroundColor: background,
          color,
        }}
      >
        {status || "Pending"}
      </Box>
    );
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        maxHeight: "500px",
        overflow: "auto",
      }}
    >
      <Table sx={{ minWidth: 650 }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerStyle}>Asset Name</TableCell>
            <TableCell sx={headerStyle}>Recommended Rules</TableCell>
            <TableCell sx={headerStyle}>Configuration</TableCell>
            {finalResult && (
              <>
                <TableCell sx={headerStyle}>DQ Job Status</TableCell>
                <TableCell sx={headerStyle}>View Result</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {(assets || []).map((row, index) => (
            <TableRow
              key={row.id || row.name || index}
              sx={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                "&:hover": {
                  backgroundColor: "#f0f8ff",
                  transition: "background-color 0.2s ease",
                },
              }}
            >
              <TableCell
                sx={{
                  ...cellStyle,
                  fontWeight: 600,
                  color: "#2c3e50",
                }}
              >
                {row.name}
              </TableCell>
              <TableCell sx={{ ...cellStyle, color: "#555" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => onFetchRuleSuggestions(row.id)}
                  disabled={
                    ruleSuggestionsLoading && ruleSuggestionsLoadingId === row.id
                  }
                  sx={{
                    color: "#bb1ccc",
                    borderColor: "#bb1ccc",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "#f0f8ff",
                      borderColor: "#bb1ccc",
                    },
                    "&:disabled": {
                      color: "#9ca3af",
                      borderColor: "#9ca3af",
                    },
                  }}
                >
                  {ruleSuggestionsLoading && ruleSuggestionsLoadingId === row.id
                    ? "Loading..."
                    : "View Rules"}
                </Button>
              </TableCell>
              <TableCell sx={cellStyle}>
                <IconButton
                  aria-label="settings"
                  onClick={() => onOpenConfig(row.id, row.name)}
                  sx={{
                    color: "#bb1ccc",
                    "&:hover": {
                      backgroundColor: "#f0f8ff",
                    },
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </TableCell>
              {finalResult && (
                <>
                  <TableCell sx={cellStyle}>
                    {getDQStatusPill
                      ? getDQStatusPill(row.dq_job_status)
                      : renderStatusPill(row.dq_job_status)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    <Button
                      variant="text"
                      sx={{
                        color: "#bb1ccc",
                        fontWeight: 600,
                        "&:hover": {
                          backgroundColor: "#f0f8ff",
                        },
                      }}
                      onClick={() => onViewResult(row.id)}
                    >
                      View Result
                    </Button>
                  </TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DQSummaryTable;

